
export const pagination = `
     {
        total
        limit
        page
        pages
        hasPrevPage
        hasNextPage
     }
`